var _dec, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import injectStyles from '4finance-components';
import { Form } from '4finance-onion-form';
import translate from '4finance-translate';
import styles from './UserError.jss';
import { SubmitButton } from '../../fields';
import ResetRecoverType from '../ResetRecoverType';
import getErrorCodeTranslation, { getErrorCodeDescription } from '../../helpers/getErrorCodeTranslation';
var ErrorIcon = function ErrorIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M30 33.75a3.75 3.75 0 0 1-7.5 0 3.751 3.751 0 0 1 7.5 0M57.5 33.75a3.75 3.75 0 0 1-7.5 0 3.751 3.751 0 0 1 7.5 0"
  }), React.createElement("path", {
    d: "M22.67 56.033a1.5 1.5 0 1 1-2.176-2.066c5.257-5.537 12.246-8.652 19.505-8.652 7.261 0 14.252 3.115 19.508 8.652a1.5 1.5 0 0 1-2.176 2.066C52.632 51.082 46.423 48.315 40 48.315c-6.421 0-12.63 2.767-17.33 7.718z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M40 77c20.435 0 37-16.565 37-37S60.435 3 40 3 3 19.565 3 40s16.565 37 37 37zm0 3C17.909 80 0 62.091 0 40S17.909 0 40 0s40 17.909 40 40-17.909 40-40 40z",
    fillRule: "nonzero"
  })));
};
ErrorIcon.defaultProps = {
  viewBox: "0 0 80 80",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var UserError = (_dec = injectStyles(styles), translate(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UserError, _React$PureComponent);
  function UserError() {
    _classCallCheck(this, UserError);
    return _possibleConstructorReturn(this, _getPrototypeOf(UserError).apply(this, arguments));
  }
  _createClass(UserError, [{
    key: "_getTextFromErrorCode",
    value: function _getTextFromErrorCode() {
      var _this$props = this.props,
        msg = _this$props.msg,
        errorCode = _this$props.errorCode;
      return msg(getErrorCodeTranslation(errorCode));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        tryAgainOrOther = _this$props2.tryAgainOrOther,
        onTryAgainClick = _this$props2.onTryAgainClick,
        onContactSupportClick = _this$props2.onContactSupportClick,
        classes = _this$props2.classes,
        msg = _this$props2.msg,
        cnt = _this$props2.cnt,
        errorCode = _this$props2.errorCode;
      var errorText = this._getTextFromErrorCode();
      var errorDescr = getErrorCodeDescription(errorCode);
      return React.createElement("div", {
        className: classes.container
      }, React.createElement("div", {
        className: classes.icon
      }, React.createElement(ErrorIcon, null)), React.createElement("h1", {
        className: classes.heading
      }, errorText || cnt('error.general')), errorDescr && React.createElement("p", {
        className: classes.description
      }, cnt(errorDescr)), React.createElement("div", null, tryAgainOrOther && React.createElement(Form, {
        name: "userError",
        onSubmit: onTryAgainClick
      }, React.createElement(SubmitButton, null, msg('error.button')))), tryAgainOrOther && React.createElement(ResetRecoverType, {
        onContactSupportClick: onContactSupportClick
      }));
    }
  }]);
  return UserError;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'UserError'), _defineProperty(_class2, "defaultProps", {
  errorCode: '',
  tryAgainOrOther: false,
  classes: {},
  cnt: function cnt() {
    return '';
  },
  msg: function msg() {
    return '';
  },
  counter: 0
}), _temp)) || _class) || _class);
export { UserError as default };